import { gql } from "@apollo/client";

// Define the GraphQL query for fetching selected images
export const GET_IMAGES_QUERY = gql`
  query GetSelectedImages($input: SelectedImagesInput!) {
    getSelectedImages(input: $input) {
      libraryCards {
        startup # Changed from 'customer' to 'startup'
        bucket
        s3Url
        thumbnailUrl
        tags
        createdAt
      }
    }
  }
`;

// New query for fetching pre-signed URLs
export const GET_PRESIGNED_URLS_QUERY = gql`
  query GetPresignedUrls($input: PresignedUrlsInput!) {
    getPresignedUrls(input: $input) {
      presignedUrls
    }
  }
`;

export const GET_PRESIGNED_GET_URLS_QUERY = gql`
  query GetPresignedUrls($input: PresignedUrlsInput!) {
    getPresignedUrls(input: $input) {
      presignedUrls
    }
  }
`;
